* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
  margin-top: 10px;
}

#at-least-one-selected {
  padding-left: 0;
  padding-right: 0;
}

gz-form-field {
  --margin-bottom-wrapper: 0;
}

gz-toggle {
  --margin-vertical: 6px;
}
